import { render, staticRenderFns } from "./build-truck-load.html?vue&type=template&id=73133849&scoped=true&"
import script from "./build-truck-load.ts?vue&type=script&lang=js&"
export * from "./build-truck-load.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73133849",
  null
  
)

export default component.exports